module.exports = __webpack_public_path__ + "static/media/2.d9a97fc4.png";